<template>
  <b-row v-if="hasAppliedFilters" class="mb-3">
    <b-col cols="12">
      <b-row align-v="start">
        <b-col cols="12" class="mb-2">
          <p class="text-md text-uppercase text-blue-500 mb-0">
            {{ $t('childrenFilter.selectedFilters') }}
          </p>
        </b-col>
        <b-col cols="12" class="mb-2 mb-lg-0">
          <b-row align-v="center" align-h="start" no-gutters>
            <b-col v-for="(filter, index) in appliedFilters.entries()" :key="index" cols="auto">
              <b-badge
                v-if="!keys.includes(filter[0])"
                class="px-3 py-1 mr-3 mb-2 mb-md-0 border border-2 filter-chip"
                variant="white"
                pill
              >
                <span class="line-height text-md text-blue-500 font-weight-normal">
                  {{ filterText(filter).value }}
                </span>
                <b-button-close
                  @click="removeFilter(filterText(filter))"
                  text-variant="black"
                  class="outline-white"
                >
                  <template v-slot:default><b-icon-plus rotate="45" /></template>
                </b-button-close>
              </b-badge>
            </b-col>
            <b-col cols="12" md="auto" class="font-weight-bold text-md text-primary mt-md-0">
              <a @click.prevent="removeAll" href="#">
                {{ $t('childrenFilter.removeSelectedFilters') }}
                <b-spinner
                  v-if="getLoader && mLoader"
                  variant="primary"
                  small
                  class="ml-1"
                ></b-spinner>
              </a>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import paramsDictionary from '@/helpers/paramsDictionary'
import { camelToSnakeCase } from '@/helpers/caseStyles'
import appliedFilters from '@/mixins/appliedFilters'

export default {
  name: 'SelectedFilters',
  mixins: [appliedFilters],
  computed: {
    resource() {
      return this.$store.getters['filter/getResourceFilter']
    },
    getLoader() {
      return this.$store.getters['filter/getLoader']
    }
  },
  data() {
    return {
      keys: ['open_fundraising', 'limit', 'offset'],
      mLoader: false
    }
  },
  methods: {
    filterText(iterator) {
      const [key, value] = iterator
      const resourceKey = key.replace(/\[\]/g, '')

      const resource = this.getResourceByKey(resourceKey)
      const mappedValue = this.getResourceValueById(resource, value, resourceKey)
      return mappedValue || { value, key: resourceKey }
    },
    getResourceByKey(key) {
      let resourceKey = Object.entries(paramsDictionary).find(
        (el) => camelToSnakeCase(el[1]) === key
      )
      resourceKey = resourceKey ? camelToSnakeCase(resourceKey[0]) : key
      return this.resource[resourceKey]
    },
    getResourceValueById(resource, id, key) {
      if (resource) {
        const value = resource.filter((el) => el.id === parseInt(id, 10))
        if (value.length > 0) {
          return {
            id: value[0].id,
            value: value[0].title || value[0].name || value[0].display_value,
            key
          }
        }
      }
      return null
    },
    removeFilter(filter) {
      this.resetOffset()
      this.$store.dispatch('filter/removeFilter', filter)
    },
    removeAll() {
      if (this.getLoader) {
        return
      }
      this.mLoader = true
      this.$store.commit('filter/setParameters')
      this.resetOffset()
      this.$store.dispatch('filter/getFilter').finally(() => {
        this.mLoader = false
      })
    },
    resetOffset() {
      this.$store.commit('filter/setPagination', {
        path: 'offset',
        value: 0
      })
    }
  }
}
</script>
